import rTree from '../api/r-tree'
import mapSearch from './mapSearch'
import fetchServices from './fetchServices'


const onRTreeComplete = dispatch => (err, estates, groups) => {
  if(err) { 
    return console.error('failed to fetch groups from r-tree', err)
  }
  dispatch({type: 'change_map_markers', estates, groups})
}

export default (bounds, zoom) => (dispatch, getState) => {
  var now = Date.now();
  dispatch({type: 'update_view_port', bounds, zoom})
  //rTree(bounds, onRTreeComplete(dispatch))
  dispatch(mapSearch())
  dispatch(fetchServices())
  
}



/** WEBPACK FOOTER **
 ** ./app/actions/updateViewPort.js
 **/